import vine from '@vinejs/vine'
import '~/validators/configureVine'

export const createAgentsValidator = vine.create(
    vine.object({
        nni: vine.string().trim().maxLength(8),
        telMob: vine.string().trim().maxLength(18).nullable(),
        telFix: vine.string().trim().maxLength(18).nullable(),
        ageDesc: vine.string().trim().maxLength(180).nullable(),
        fct: vine.string().trim().maxLength(255).nullable(),
        firstName: vine.string().trim().maxLength(80).nullable(),
        lastName: vine.string().trim().maxLength(80).nullable(),
        email: vine.string().trim().maxLength(255).email().nullable(),
        sitLib: vine.string().trim().maxLength(68),
        fsdum: vine.string().trim().maxLength(9),
        tags: vine.array(vine.string()).nullable().optional(),
    })
)

export const updateAgentsValidator = vine.create(
    vine.object({
        nni: vine.string().trim().maxLength(8),
        telMob: vine.string().trim().maxLength(18).nullable(),
        telFix: vine.string().trim().maxLength(18).nullable(),
        ageDesc: vine.string().trim().maxLength(180).nullable(),
        fct: vine.string().trim().maxLength(255).nullable(),
        firstName: vine.string().trim().maxLength(80).nullable(),
        lastName: vine.string().trim().maxLength(80).nullable(),
        email: vine.string().trim().maxLength(255).email().nullable(),
        sitLib: vine.string().trim().maxLength(68),
        fsdum: vine.string().trim().maxLength(9),
        tags: vine.array(vine.string()).nullable(),
    })
)

export const patchAgentsValidator = vine.create(
    vine.object({
        nni: vine.string().trim().maxLength(8).optional(),
        telMob: vine.string().trim().maxLength(18).nullable().optional(),
        telFix: vine.string().trim().maxLength(18).nullable().optional(),
        ageDesc: vine.string().trim().maxLength(180).nullable().optional(),
        fct: vine.string().trim().maxLength(255).nullable().optional(),
        firstName: vine.string().trim().maxLength(80).nullable().optional(),
        lastName: vine.string().trim().maxLength(80).nullable().optional(),
        email: vine.string().trim().maxLength(255).email().nullable().optional(),
        sitLib: vine.string().trim().maxLength(68).optional(),
        fsdum: vine.string().trim().maxLength(9).optional(),
        tags: vine.array(vine.string()).nullable().optional(),
    })
)
